/**
 * walks up from an element to the closest ancestor set up to scroll its own content,
 * checked by CSS overflow alone (not current overflow amount, which can change after this runs)
 * @param element - element to start the search from
 */
export function getScrollableParent(element) {
  let parent = element?.parentElement;
  while (parent) {
    const { overflowY } = window.getComputedStyle(parent);
    if (overflowY === 'auto' || overflowY === 'scroll') return parent;
    parent = parent.parentElement;
  }
  return null;
}

/**
 * scrolls the closest scrollable ancestor so the element sits at its top,
 * scrollIntoView is avoided on purpose because it also scrolls the page and any other ancestor
 * @param element - element to bring to the top of its scroll container
 * @param offset - pixels of breathing room left above the element
 */
export function scrollElementToContainerTop(element, offset = 8) {
  if (!element) return;

  const container = getScrollableParent(element);
  if (!container) return;

  const delta =
    element.getBoundingClientRect().top - container.getBoundingClientRect().top;
  const maxScroll = Math.max(
    0,
    container.scrollHeight - container.clientHeight
  );
  const target = Math.min(container.scrollTop + delta - offset, maxScroll);

  container.scrollTo({ top: Math.max(0, target), behavior: 'smooth' });
}
